enum ApplicationSource {
    Jobboard = 'job-board',
    MyNetwork = 'my-network',
    Agency = 'agency',
    FreeApplication = 'free-application',
    Other = 'other',
}

export default ApplicationSource;
